export default __webpack_public_path__ + "static/media/icon-record-inverted.79074b71.svg";